import { useMutation } from "@apollo/client";

import { MapEditorPlannerAreaPanel_PlannerAreaRemoveProtocolDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useRemovePlannerAreaProtocolMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaRemoveProtocolDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const removePlannerAreaProtocol = (plannerAreaId: string, protocolId: string) =>
        mutate({
            variables: {
                input: {
                    plannerAreaId,
                    protocolId,
                },
            },
        });

    return [removePlannerAreaProtocol, result] as const;
}
